import { request } from '../../request';

interface IOrdersFetch {
    count: number,
    offset: number
}

export const meOrdersFetch = (query: IOrdersFetch) => {
	return request({ url: '/profile/orders', headers: { authorization: true }, retryOnError: true, params: query });
};